import dynamic from "next/dynamic";

export const DynamicPageSeo = dynamic(() => import("./component"));
